import { DevConfigPanel as SharedDevConfigPanel } from 'Components/DevConfigPanel';

export const DevConfigPanel = () => (
  <SharedDevConfigPanel showPagination={true} panelWidth={320} rightOffset="-23em" />
);
